import { render, staticRenderFns } from "./ButtonScrollToTop.vue?vue&type=template&id=5369b772&scoped=true&lang=pug"
import script from "./ButtonScrollToTop.vue?vue&type=script&lang=js"
export * from "./ButtonScrollToTop.vue?vue&type=script&lang=js"
import style0 from "./ButtonScrollToTop.vue?vue&type=style&index=0&id=5369b772&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5369b772",
  null
  
)

export default component.exports